import {useState} from '../../app3';
import monkey from '../../../public/svg/TwoFactorSetupMonkeyCloseAndPeek.svg';

import CountryDropdown from './CountryDropdown';

export default function AuthCode({props}) {
  const [state, patch] = useState({
    authCode: '',
  });

  function handleAuthCode(e) {
    patch({
      authCode: e.target.value,
    });

    props.handleNextClick(e, state.authCode);
  }

  return (h) => h('div', {
    children: [
      h('div', {attrs: {class: 'login-container'}}, [
        h('div', {attrs: {class: 'row'}}, [
          h('div', {attrs: {class: 'section-image'}}, [
            h('img', {
              attrs: {
                src: monkey,
                alt: 'Telegram Messenger',
              },
            }),
          ]),
        ]),
        h('div', {attrs: {class: 'row'}}, [
          h('p', {attrs: {class: 'intro-text'}}, 'We have sent you an SMS with the code.'),
        ]),
        h('div', {attrs: {class: 'row'}}, [
          h('div', {attrs: {class: 'tg-form-input'}}, [
            h('div', {attrs: {class: 'tg-input'}}, [
              h('input', {
                attrs: {
                  type: 'text',
                  required: 'required',
                  value: state.authCode,
                },
                on: {
                  change: handleAuthCode
                }
              }),
              h('label', 'Phone Number'),
            ]),
          ]),
        ]),
      ]),
    ],
  });
}
